import {
  ExploreAssetAction,
  useExploreAssetActionType,
} from "./useExploreAssetActionType.ts";

export function useExploreBookAvailable(asset?: VST.Bridge.Asset) {
  // simplified boolean for whether an explore book could be borrowed/opened
  const exploreAction = useExploreAssetActionType(asset);
  return !!(asset && exploreAction !== ExploreAssetAction.None);
}
